module.exports = __webpack_public_path__ + "img/notice.e58635aa.png";